<template>
  <div class="w-100 pl-3" v-if="current && current.id >= 0" v-loading="isLoading">
    <div class="row">
      <div class="col-xl-8">
        <!-- Title w/ date time -->
        <h4 class="title title-up">
          <span style="font-size:xxx-large;">{{order.order_number}}</span> |
          <span style="font-size:x-large;">
            {{ {'eat_in': '內用', 'to_go': '外帶', 'delivery': '外送'}[order.meal_types] }}
          </span>
          <span class="text-muted" style="font-size:large;" v-if="order.meal_types === 'eat_in'">
            桌號：{{order.table_number}}
          </span>
          <br>
          <small class="text-muted">下單：{{order.created_at | toDateString}}</small><br>
          <div v-if="order.meal_types === 'delivery' && order.lala_take_meal_time > 0">
            <small class="text-muted">
              物流取餐：{{order.lala_take_meal_time | toDateString}}
            </small><br>
          </div>
          <small class="text-muted" v-if="order.take_meal_time">
            客人取餐：{{order.take_meal_time | toDateString}}
          </small>
        </h4>
        <!-- User phone number -->
        <div class="d-flex align-items-center" v-if="user.phone">
          <a :href="'tel:'+user.phone"><font-awesome-icon icon="phone" size="2x"/></a>&nbsp;&nbsp;
          <span style="font-size:large;">{{user.phone | toTwnPhoneString}}</span>
        </div>
      </div>
      <div class="col-xl-4 pt-4 d-flex align-items-center justify-content-end">
        <el-button type="primary" circle icon="el-icon-info" class="mr-4" @click="isMoreInfoShown = true"></el-button>

        <el-button type="success" icon="el-icon-document-checked" @click="acceptOrder"
          v-if="current.status === 'new'">
          接單
        </el-button>
        <el-button type="primary" icon="el-icon-success" @click="completeOrder"
          v-if="current.status === 'accepted'">
          完成
        </el-button>
        <el-button type="danger" icon="el-icon-remove" @click="rejectOrder"
          :disabled="['cancelled', 'rejected'].indexOf(current.status) >= 0">
          取消
        </el-button>
      </div>
    </div>
    

    <!-- Action buttons -->
    <!-- <div>
      
    </div> -->
    <el-divider></el-divider>

    <!-- Cart items -->
    <el-table :data="cart">
      <!-- <el-table-column prop="product_id" label="#" width="80">
      </el-table-column> -->
      <!-- <el-table-column prop="product_name" label="品項" class-name="h5">
      </el-table-column> -->
      <el-table-column prop="product_name" label="品項">
        <template slot-scope="{row}">
          <h5 class="mb-0">{{row.product_name}}</h5>
          <p class="mb-0" v-if="row.display && row.display.length">{{row.display}}</p>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="product_image" label="圖片" width="120" align="center">
        <template slot-scope="{row}">
          <img :src="row.product_image" alt="...">
        </template>
      </el-table-column>
      <el-table-column prop="display" label="加購項">
      </el-table-column> -->
      <el-table-column prop="product_name" label="數量" width="80" align="center" class-name="h6">
        <template slot-scope="{row}">{{row.qty}}</template>
      </el-table-column>
      <el-table-column label="小計" width="120" align="right" class-name="h6">
        <template slot-scope="{row}">
          ${{Number((row.product_amount + row.addon_amount) * row.qty).toLocaleString()}}
        </template>
      </el-table-column>
    </el-table>

    <!-- Addon -->
    <div v-if="addon">
      <el-table :data="[addon]" :show-header="false">
        <el-table-column prop="display" label="描述" class-name="h5">
          <div slot-scope="{row}"><b>整單加購：</b>{{row.display}}</div>
        </el-table-column>
        <el-table-column prop="amount" label="加價" width="120" align="right" class-name="h5">
          <div slot-scope="{row}">${{Number(row.amount).toLocaleString()}}</div>
        </el-table-column>
      </el-table>
    </div>

    <br>
    <!-- Notes (user remark) -->
    <div class="card mb-3" v-if="order.notes && order.notes.length">
      <div class="card-body">
        <h5 class="card-title">備註</h5>
        <p class="card-text">{{order.notes}}</p>
      </div>
    </div>

    <!-- More-info dialog -->
    <el-dialog title="訂單資訊" :visible.sync="isMoreInfoShown" width="80%">
      <el-table :data="orderDetailData" :show-header="false">
        <el-table-column prop="key1" label="Key1" class-name="col-attr-name"></el-table-column>
        <el-table-column prop="val1" label="Val1"></el-table-column>
        <el-table-column prop="key2" label="Key2" class-name="col-attr-name"></el-table-column>
        <el-table-column prop="val2" label="Val2"></el-table-column>
      </el-table>
      <br>
      <!-- User info FIXME: Not needed in POS mode -->
      <!-- <div class="card mb-3" v-if="user">
        <div class="row no-gutters">
          <div class="col-md-2">
            <img :src="user.image" class="card-img" alt="...">
          </div>
          <div class="col-md-10">
            <div class="card-body">
              <h5 class="card-title">{{user.name}} |<small class="text-muted">{{user.email}}</small></h5>
              <p class="card-text">{{user.phone}}</p>
            </div>
          </div>
        </div>
      </div> -->
    </el-dialog>

  </div>

  <div v-else class="h-100 d-flex align-items-center justify-content-center">
    <span class="text-muted h3">請選擇訂單以顯示內容</span>
  </div>
</template>

<script>
import { fsdb } from '../../firestore';
import axios from 'axios';
import moment from 'moment';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faPhone);

export default {
  name: 'PosOrderDetail',

  props: {
    // orderId: {
    //   type: Number,
    //   default: -1
    // },
    current: Object,
    shopId: Number,
    isPub: Boolean
  },

  mounted() {

  },

  methods: {
    getOrderDetail() {
      this.isLoading = true;
      axios.get(
        `${process.env.VUE_APP_APIHOST}/qcpos/orders/${this.current.id}/cart` +
        `?includeOrderData=true`
      )
      .then(response => {
        console.log(`Cart of order ${this.orderId}`, response.data);
        this.cart = response.data.cart;
        this.user = response.data.user;
        this.addon = response.data.account_addon;
        this.order = response.data.order;

        this.isLoading = false;
      })
      .catch(err => {
        this.$notify.error({
          title: '此訂單無明細！',
          message: err.data.message
        });
        this.isLoading = false;
      });
    },

    acceptOrder() {
      console.warn(`Trying to accept order ${this.orderId}...`);
      axios.post(`${process.env.VUE_APP_APIHOST}/qcpos/orders/${this.order.order_id}/accept`)
      .then(response => {
        // this.current.status = 'accepted';
        // this.changeStatusTo('accepted');
        this.$message({
          type: 'success', message: `已接受此訂單：${this.order.order_number}`
        });
      })
      .catch(err => {
        console.error('acceptOrder failed', err);
        this.$message.error(`無法接受訂單（${this.orderId}）：${err.data.message}`);
      });
    },
    completeOrder() {
      console.warn(`Trying to complete order ${this.orderId}...`);
      axios.post(`${process.env.VUE_APP_APIHOST}/qcpos/orders/${this.order.order_id}/complete`)
      .then(response => {
        // this.current.status = 'done';
        // this.changeStatusTo('done');
        this.$message({
          type: 'success', message: `已完成此訂單：${this.order.order_number}`
        });
      })
      .catch(err => {
        console.error('completeOrder failed', err);
        this.$message.error(`無法完成訂單（${this.orderId}）：${err.data.message}`);
      });
    },
    rejectOrder() {
      console.warn(`Trying to reject order ${this.order.order_id}...`);
      axios.post(`${process.env.VUE_APP_APIHOST}/qcpos/orders/${this.order.order_id}/cancel`)
      .then(response => {
        // this.current.status = 'rejected';
        // this.changeStatusTo('rejected');
        this.$message({
          type: 'success', message: `已取消此訂單：${this.order.order_number}`
        });
      })
      .catch(err => {
        console.error('rejectOrder failed', err);
        this.$message.error(`無法取消訂單（${this.order.order_id}）：${err.data.message}`);
      });
    },

    //NOTE: This simply alters the status of this order in Firestore. This should triggers real-time update.
    changeStatusTo(status) {
      fsdb.doc(`shops/${this.shopId}/orders/${this.order.id}`)
      .set({status: status}, {merge: true})
      .then(() => {
      })
      .catch(err => {
        console.error('changeStatusTo failed', err);
        this.$message.error(`狀態更新失敗（${this.order.order_id}-${status}）：${err.message}`);
      });
    },

    // updateCurrentStatus(status) {
    //   this.current
    // }
  },

  data() {
    return {
      cart: [],
      user: undefined,
      addon: undefined,
      order: undefined,

      isLoading: false,
      isMoreInfoShown: false
    }
  },

  computed: {
    orderDetailData() {
      let payTypes = {
        'cash': '現金', 'multiple': '線上支付',
        'qrpay_apple': 'Apple Pay', 'qrpay_google': 'Google Pay',
        'qrpay_line': 'LINE Pay', 'qrpay_credit': '一般信用卡'
      };
      let mealTypes = {'eat_in': '內用', 'to_go': '外帶', 'delivery': '外送'};
      let ret = [
        { key1: '訂單編號（ID）', val1: this.order.order_id,
          key2: '流水號', val2: this.order.order_number},
        { key1: '商品金額', val1: `$${Number(this.order.cart).toLocaleString()}`,
          key2: '用餐型態', val2: mealTypes[this.order.meal_types]},
        { key1: '運費', val1: `$${Number(this.order.delivery_fee).toLocaleString()}`,
          key2: '已確認？', val2: {0: '否', 1: '是'}[this.order.is_confirmed]},
        { key1: '店家負擔', val1: `$${Number(this.order.shop_covered_fee).toLocaleString()}`,
          key2: '已取消？', val2: {0: '否', 1: '是'}[this.order.is_cancelled]},
        { key1: '實付', val1: `$${Number(this.order.amount).toLocaleString()}`},
        { key1: '付款方式', val1: payTypes[this.order.payment_types]},
      ];
      if (this.order.meal_types === 'delivery') {
        ret = ret.concat([
          {key1: '外送地址', val1: this.order.delivery_address},
          {key1: '物流取餐時間', val1: moment.unix(this.order.lala_take_meal_time).format('YYYY/MM/DD HH:mmA')},
          {key1: '送餐需時', val1: this.order.delivery_time + ' 分鐘'},
          {key1: '外送備註', val1: this.order.lala_notes},
        ]);
      }

      return ret;
    }
  },

  filters: {
    toDateString: ts => {
      return moment.unix(ts).format('M/DD h:mmA');
    },
    toTwnPhoneString: phone => {
      if (phone.indexOf('+886') === 0)
        return '0' + phone.substring(4);
      if (phone.indexOf('886') === 0)
        return '0' + phone.substring(3);
      return phone;
    }
  },

  watch: {
    current: {
      immediate: false,
      handler(obj) {
        // console.log('watch current', obj);
        if (obj.id > -1)
          this.getOrderDetail();
      }
    }
  }
}
</script>

<style scoped>
button.el-button:not(.is-circle) {
  height: 100%;
  font-size: x-large;
}
</style>

<style>
.col-attr-name {
  font-weight: bold;
}
</style>